module.exports = __webpack_public_path__ + "img/type-icon.b532d6fc.png";